
export default {
  methods: {
    handleChange (event) {
      this.$store.commit('setHotelSort', event.target.value)
    }
  }
}
